var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m71 264 71 72-12 12-71-72zM288 47l71 71-12 12-71-71zM142 389h264v17H125z M389 17c12 12 17 27 17 42s-5 30-17 41L110 380c-1 1-3 2-5 2l-94 24c-5 1-10-1-11-6v-4l24-95c1-2 2-3 3-4L306 17c12-11 27-17 42-17s30 6 41 17zm0 42c0-11-4-22-12-30s-19-12-29-12c-11 0-22 4-30 12L40 307l-20 79 79-20L377 88c8-8 12-19 12-29z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.7294146262a2aebc8fabf0fbedf8f3bb.svg";
export { ForwardRef as ReactComponent };